export default {


  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_eRV1v9xeZ',
    APP_CLIENT_ID: "6pv304fntoljvh846sbkkil0f1",
    IDENTITY_POOL_ID: 'us-east-1:b121a5be-1908-491c-88c9-882ef6dbcb02'
  }
};